<template>
  <span v-if="showViewDetails()">
    <i
      class="el-icon-search icon-action"
      id="btn-layout-template-detail-dialog"
      @click="handleOpenDialog"
      size="mini"
      icon="el-icon-plus"
      v-if="showGridIcon"
    ></i>
    <el-dialog
      id="layout-template-detail-dialog"
      :close-on-click-modal="false"
      :title="$t('layoutTemplate.viewDetailsTitle')"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-row :gutter="10">
        <el-col :span="3" class="list-name">
          <label class="margin-bottom-small-list">{{ $t('layoutTemplate.dayOfWeek') }}</label>
        </el-col>
        <el-col :span="5">
          <span class="span-small-list">{{ dayOfWeek }}</span>
        </el-col>
        <el-col :span="3">
          <label class="margin-bottom-small-list">{{ $t('layoutTemplate.code') }}</label>
        </el-col>
        <el-col :span="5">
          <span class="span-small-list">{{ code }}</span>
        </el-col>
        <el-col :span="3">
          <label class="margin-bottom-small-list">{{ $t('layoutTemplate.name') }}</label>
        </el-col>
        <el-col :span="5">
          <span class="span-small-list">{{ name }}</span>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="24" :lg="12">
          <storage-location
            :layoutTemplateId="layoutTemplateId"
            :layoutType="layoutTypeTemplate"
            :layoutTemplateName="layoutTemplateName"
            @loadStoragePosition="handleLoadStoragePosition"
            @cleanStorageLocation="cleanSelectedStorageLocation"
            ref="storage-locations" />
        </el-col>

        <el-col :md="24" :lg="12">
          <storage-position
            :layoutTemplateId="layoutTemplateId"
            :storageLocationId="selectedStorageLocation.storageLocationId"
            :storageLocationCode="selectedStorageLocation.storageLocation"
            :area="selectedStorageLocation.area"
            :shipperGroupName="selectedStorageLocation.shipperGroupName"
            :layoutType="layoutTypeTemplate"
            :layoutTemplateName="layoutTemplateName"
          />
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';
import StorageLocation from '../../components/StorageLocation';
import StoragePosition from '../../components/StoragePosition';

export default {
  name: 'ViewDetails',
  components: {
    StorageLocation,
    StoragePosition
  },
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    dayOfWeek: {
      type: String,
      default: ''
    },
    code: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    showGridIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    layoutTypeTemplate() {
      return constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.TEMPLATE;
    },
    layoutTemplateName() {
      return this.dayOfWeek
        .concat(' - ')
        .concat(this.code)
        .concat(' - ')
        .concat(this.name);
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedStorageLocation: {
        layoutTemplateId: 0,
        storageLocationId: 0,
        storageLocation: '',
        area: '',
        shipperGroupName: '',
        positionsAssigned: ''
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.cleanSelectedStorageLocation();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs['storage-locations'].handleSearch();
      });
    },
    showViewDetails() {
      return this.$can(this.permissions.WAREHOUSE.VIEW_LAYOUT_TEMPLATES);
    },
    handleLoadStoragePosition(storageLocation) {
      this.selectedStorageLocation = storageLocation;
    },
    handleClose(done) {
      this.cleanSelectedStorageLocation();
      this.$store.dispatch('layoutTemplate/search', {});
      done();
    },
    cleanSelectedStorageLocation() {
      this.selectedStorageLocation = {
        layoutTemplateId: 0,
        storageLocationId: 0,
        storageLocation: '',
        area: '',
        shipperGroupName: '',
        positionsAssigned: ''
      };
    }
  }
};
</script>
